export const roundFloat = (float, round) => Number(float.toFixed(round));
